import React from 'react';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';

import { getDesiredDates, getListingErrorMessage } from '../selectors';

export function useDesiredDates() {
  const dates = useSelector(getDesiredDates);
  const listingErrorMessage = useSelector(getListingErrorMessage);

  const desiredDates = React.useMemo(() => {
    return listingErrorMessage && listingErrorMessage?.length > 0
      ? {
          startDate: null,
          endDate: null,
        }
      : dates;
  }, [listingErrorMessage, dates]);

  const hasDesiredDates = React.useMemo(
    () =>
      !!desiredDates.startDate &&
      !dayjs(desiredDates.startDate).isBefore(dayjs().startOf('day')) &&
      !!desiredDates.endDate,
    [desiredDates.startDate, desiredDates.endDate],
  );

  return {
    hasDesiredDates,
    desiredDates,
  };
}
